var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-[800px]"},[_c('el-skeleton',{attrs:{"rows":6,"animated":"","loading":_vm.loading}},[_c('div',{ref:"container",staticClass:"min-h-[800px] opacity-0 transition-opacity duration-1000 ease-in",class:{'opacity-100': !_vm.loading},domProps:{"innerHTML":_vm._s(_vm.dynamicComponent)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }